import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import VideocamIcon from '@mui/icons-material/Videocam';
import Tooltip from '@mui/material/Tooltip';
import IconButton from 'components/@extended/IconButton';
import useHeaderTheme from 'hooks/useHeaderTheme';

export default function VideoMonShortCut() {
  const navigate = useNavigate();
  const { iconColor, hoverColor } = useHeaderTheme();

  return (
    <Box sx={{ flexShrink: 0, ml: 0.75 }}>
      <Tooltip title="Live Streaming">
        <IconButton
          color="secondary"
          variant="light"
          sx={(theme) => ({
            color: iconColor,
            bgcolor: 'transparent',
            '&:hover': { bgcolor: hoverColor },
            ...theme.applyStyles('dark', { bgcolor: 'transparent' })
          })}
          aria-label="video shortcut"
          onClick={() => navigate('/live-streaming?name=live-streaming')}
        >
          <VideocamIcon sx={{ color: iconColor }} />
        </IconButton>
      </Tooltip>
    </Box>
  );
}
